import request from '@/utils/request.js'

export function getvendingmachinelist(data) {
  return request.get('/api/H5/vendingmachine/getvendingmachinelist', {
    params: data
  })
}
export function getvendingmachinedetail(data) {
  return request.get('/api/H5/vendingmachine/getvendingmachinedetail', {
    params: data
  })
}
export function getvendproducttype(data) {
  return request.get('/api/H5/vendingmachine/getvendproducttype', {
    params: data
  })
}
export function getvendproductpage(data) {
  return request.get('/api/H5/vendingmachine/getvendproductpage', {
    params: data
  })
}
export function getvendcoffeeproductpage(data) {
  return request.get('/api/H5/vendingmachine/getvendcoffeeproductpage', {
    params: data
  })
}
